import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import PropTypes from 'prop-types';
import { ACCOUNT_LOCKED, WRONG_PASSWORD } from '../../../../constants/ErrorTypes';
import { linkAccount } from '../../../../actions/authenticationActions';
import { ROUTE_LOGIN, ROUTE_LOGIN_LINK_SUCCESS } from '../../../../constants/Routes';

import LinkAccountsForm from './LinkAccountsForm';

@connect(
	({ authentication }) => ({
		authentication,
	}),
	{ linkAccount }
)
export default class LinkAccountsContainer extends Component {
	static propTypes = {
		history: PropTypes.object.isRequired,
		linkAccount: PropTypes.func.isRequired,
		email: PropTypes.string,
		regToken: PropTypes.string,
	};

	static defaultProps = {
		email: null,
		regToken: null,
	};

	componentWillMount() {
		const { email, regToken } = this.props.authentication;
		if (!email || !regToken) this.props.history.push(ROUTE_LOGIN);
	}

	handleSubmit = ({ password }) => {
		const { authentication, history, linkAccount } = this.props;
		const { email, regToken, loginProvider } = authentication;
		const userData = {
			email,
			password,
			regToken,
			provider: loginProvider,
		};

		return linkAccount(userData)
			.then(() => history.push(ROUTE_LOGIN_LINK_SUCCESS, { loginProvider }))
			.catch((err) => {
				// Because of the valid regToken the user can keep retrying entering a password
				// even when the account is locked. During a normal login this wouldn't be possible.
				if (err.message === ACCOUNT_LOCKED || err.message === WRONG_PASSWORD) {
					throw new SubmissionError({ password: WRONG_PASSWORD });
				}
			});
	};

	render() {
		const { email } = this.props.authentication;

		return (
			<Fragment>
				<LinkAccountsForm email={email} onSubmit={this.handleSubmit} />
			</Fragment>
		);
	}
}
